import React, { useState, useRef, useEffect } from "react";
import {
  Stack,
  TextField,
  Modal,
  Fade,
  Box,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import { PDFDocument } from "pdf-lib";
import "react-image-crop/dist/ReactCrop.css";
import ReactCropper from "../Components/ReactCropper/ReactCropper";
import DragandDropFile from "../Components/DragAndDrop/DragandDrop";
import { dataURItoFile } from "../shared/commonfunctions";
import {
  uploadDocumentsAPICall,
  deleteDocumentAPICall,
} from "../shared/APICalls";
import PreviewModalPopup from "../Components/Modals/PreviewModalPopup";
import PdfModal from "../Components/PdfModal/PdfModal";
import ClearIcon from "@mui/icons-material/Clear";
import { IDeleteDocument } from "../shared/dtos";
import { LoadingButton } from "@mui/lab";
import FormatStyles from "../pages/Styles/FormatChecker.module.scss";
import UploadImage from "../Components/assets/Images/uploadblackicon.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SnackBar from "../Components/SnackBars/SnackBar";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { confirmAlert } from "react-confirm-alert";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import uploaddelete from "../Components/assets/Images/uploaddelete.svg";
import uploadview from "../Components/assets/Images/uploadview.svg";

interface Props {
  acceptedFormats: any;
  previewImage: any;
  documentRef: string;
  documentID: any;
  displayOptions: any;
  stageDetailsData: any;
  name: string;
  purpose: string;
  pdfSize: number;
  imageSize: number;
  selectedFile: any;
  setSelectedFile: any;
  setpancardUrl: any;
}
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
  borderRadius: "20px",
};

const FormatterCheckerPanFetch: React.FC<Props> = ({
  acceptedFormats,
  previewImage,
  documentRef,
  documentID,
  displayOptions,
  stageDetailsData,
  name,
  purpose,
  pdfSize,
  imageSize,
  selectedFile,
  setSelectedFile,
  setpancardUrl,
}) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showInput, setShowInput] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [showModal, setshowModal] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [showDragandDropModal, setshowDragandDropModal] = useState(false);
  const [image, setImage] = useState<any>();
  const [pdfPreviewFile, setPdfPreviewFile] = useState<any>();
  const [showPreviewModal, setshowPreviewModal] = useState(false);
  const [previewPDFFile, setpreviewPDFFile] = useState(false);
  const [imageDocumentId, setImageDocumentId] = useState("");
  const [imagedeleteLoading, setImagedeleteLoading] = useState(false);
  const [pdfdeleteLoading, setpdfdeleteLoading] = useState(false);
  const [uploadLoading, setuploadLoading] = useState(false);
  const [pdfUploadLoading, setpdfUploadLoading] = useState(false);
  const [previewLoading, setpreviewLoading] = useState(false);
  const [previewImageLoading, setpreviewImageLoading] = useState(false);

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  let PasswordTyped: any = "";

  let PagesCount: any;
  //  console.log("stageDetailsData", documentRef);

  useEffect(() => {
    setImage(stageDetailsData);
    setSelectedFile(stageDetailsData);
  }, [stageDetailsData]);

  const handleUpload = () => {
    //console.log("drag");
    // setuploadLoading(true)
    setshowDragandDropModal(true);
  };

  const handleFileChangeUpload = async (event: any) => {
    const file = event[0];
    setImage(""); // Accessing the first file from the array
    // console.log(file);
    if (!file) {
      setSelectedFile(null);
      setErrorMessage("");
      return;
    }

    const fileType = file.type.split("/")[1];

    if (!acceptedFormats.includes(fileType)) {
      setSelectedFile(null);
      setErrorMessage(
        `Invalid file format. Only ${acceptedFormats.join(
          ", ",
        )} files are accepted.`,
      );
      return;
    }

    // if (file.size > UPLOADSIZELIMIT * 1024 * 1024) {
    // PDF File Size check
    if (fileType === "pdf" && file.size > pdfSize * 1024 * 1024) {
      setSelectedFile(null);
      setErrorMessage(`File size exceeds ${pdfSize}MB limit.`);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }
    // Image File Size check
    if (
      ["png", "jpg", "jpeg"].includes(fileType) &&
      file.size > imageSize * 1024 * 1024
    ) {
      setSelectedFile(null);
      setErrorMessage(`File size exceeds ${imageSize}MB limit.`);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }

    if (fileType !== "pdf") {
      setOpen(true);
    }

    if (fileType === "pdf") {
      // setOpen(true);
      setpreviewPDFFile(true);
      setshowDragandDropModal(false);

      try {
        const bytes = await file.arrayBuffer();
        const pdfDoc = await PDFDocument.load(bytes, { updateMetadata: false });
        const pageCount = pdfDoc.getPageCount();

        PagesCount = pageCount;
      } catch (e) {
        // window.alert("File is Password Protected, Please Enter Password");
        setShowInput(true);
      }
    }

    setSelectedFile(file);
    setshowModal(true);
    const fileUrl = URL.createObjectURL(file); // Create object URL for the file
    setPreview(fileUrl); // Set the preview with the file URL

    // console.log("Object URL", fileUrl);
    setErrorMessage("");
  };

  const handlePdfPreviewDone = () => {
    setpdfUploadLoading(true);
    previewImage(selectedFile);
    setshowModal(false);
    // console.log("documentRef", documentRef);
    const formData = new FormData();
    const obj: any = {
      file: selectedFile,
      doc_ref: purpose,
      file_password: PasswordTyped,
      doc_purpose: documentRef,
    };

    formData.append("file", obj.file);
    formData.append("doc_ref", obj.doc_ref);
    formData.append("file_password", obj.file_password);
    formData.append("doc_purpose", obj.doc_purpose);
    setpreviewLoading(true);
    uploadDocumentsAPICall(formData)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("response", response);
        // console.log("responseData", responseData.data);
        setpdfUploadLoading(false);
        setShowInput(false);
        setPdfPreviewFile(responseData.data.doc_url);

        documentID("Document uploaded successfully.");
        setpreviewLoading(false);

        if (displayOptions) displayOptions(false);
      })
      .catch((error: any) => {
        previewImage("");
        setshowModal(false);
        setShowInput(false);
        setSelectedFile(null);
        setpreviewPDFFile(false);
        setPdfPreviewFile("");

        // setErrorMessage("Error Uploading")
        setpdfUploadLoading(false);
        setpreviewLoading(false);

        setErrorMessage(
          error.message.includes("Network")
            ? "Error Uploading, Please try again"
            : error.response.data.message,
        );

        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });

    setOpen(false);
  };

  const handleCloseModal = () => setshowDragandDropModal(false);

  const handleCallBack = (data: any) => {
    setshowModal(false);
    if (data === "close") {
      // setTimeout(() => {
      setImage("close");
      // }, 3000);
    } else {
      previewImage(data.getCroppedCanvas().toDataURL());
      setImage(data.getCroppedCanvas().toDataURL());

      setSelectedFile(data.getCroppedCanvas().toDataURL());
      const ImageData = data;
      const formData = new FormData();

      if (ImageData !== "undefined") {
        const canvas = ImageData.getCroppedCanvas({
          maxWidth: 1000,
          maxHeight: 1000,
        });
        const dataURL = canvas.toDataURL();
        const file = dataURItoFile(dataURL, "cropped_image.png");
        // console.log("Cropped Image File:", file);

        const obj: any = {
          file: file,
          doc_ref: purpose,
          file_password: "123456",
          doc_purpose: documentRef,
        };

        formData.append("file", obj.file);
        formData.append("doc_ref", obj.doc_ref);
        formData.append("file_password", obj.file_password);
        formData.append("doc_purpose", obj.doc_purpose);
        // console.log("hello");
        setpreviewImageLoading(true);
        uploadDocumentsAPICall(formData)
          .then((response: any) => {
            const responseData = response.data;
            //  console.log("responseDataImage", response);
            setImage(responseData.data.doc_url);
            setSelectedFile(responseData.data.doc_url);

            documentID("Document uploaded successfully.");

            setpreviewImageLoading(false);
            if (displayOptions) displayOptions(false);

            // setshowModal(false)
          })
          .catch((error: any) => {
            // console.log("error", error)
            setpreviewImageLoading(false);
            setSelectedFile(null);
            setErrorMessage(
              error.message.includes("Network")
                ? "Error Uploading, Please try again"
                : error.response.data.message,
            );

            setTimeout(() => {
              setErrorMessage("");
            }, 5000);
          });
      }
    }
  };
  const handlePreviewClick = () => {
    setshowPreviewModal(true);
  };
  const handleClosePreview = () => {
    setshowPreviewModal(false);
  };

  useEffect(() => {
    setshowDragandDropModal(false);
    if (image && image) {
      setOpen(false);
      if (image === "close") {
        setshowDragandDropModal(false);
      }
    } else {
      setOpen(true);
    }
  }, [image]);

  const handlePreviewPDFClick = () => {
    setshowPreviewModal(true);
  };

  const handledeleteImageClick = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to delete, on pressing Yes the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => {
            setImagedeleteLoading(false);
          },
        },
        {
          label: "Yes",
          onClick: () => {
            setImagedeleteLoading(true);
            let obj: IDeleteDocument = {
              doc_purpose: documentRef,
            };
            deleteDocumentAPICall(obj)
              .then((response: any) => {
                const responseData = response.data;
                documentID("");
                setSelectedFile(null);
                setImagedeleteLoading(false);
                if (displayOptions) {
                  displayOptions(true);
                }
              })
              .catch((error: any) => {
                setImagedeleteLoading(false);
              });
          },
        },
      ],
    });
  };

  const handledeleteClick = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to delete, on pressing Yes the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => {
            setImagedeleteLoading(false);
          },
        },
        {
          label: "Yes",
          onClick: () => {
            setpdfdeleteLoading(true);
            let obj: IDeleteDocument = {
              doc_purpose: documentRef,
            };
            deleteDocumentAPICall(obj)
              .then((response: any) => {
                const responseData = response.data;
                //console.log("responseData", response);
                documentID("");
                setSelectedFile(null);
                setpreviewPDFFile(false);
                setpdfdeleteLoading(false);

                if (displayOptions) {
                  displayOptions(true);
                }
              })
              .catch((error: any) => {
                setpdfdeleteLoading(false);
              });
          },
        },
      ],
    });
  };
  const handleClosePdf = () => {
    setshowModal(false);
    setShowInput(false);
    setSelectedFile(null);
    setpreviewPDFFile(false);
  };

  const selectedfileName =
    selectedFile && image !== "close" && selectedFile.name;

  return (
    <Stack
      alignItems={"flex-end"}
      style={{ borderLeft: "1px solid var(--ds-outline)" }}
    >
      <SnackBar message={errorMessage} />

      <Stack direction={"row"}>
        {!previewPDFFile && (!image || image === "close" || !selectedFile) && (
          <LoadingButton
            variant="text"
            component="label"
            sx={{
              display: "flex",
              width: "max-content",
              color: "var(--ds-text-primary)",
              borderRadius: "0px",
              boxShadow: "none",
              minWidth: "unset",
              fontSize: "12px",
              padding: "0px 10px",
            }}
            onClick={handleUpload}
            id="documentsUploadButton"
            loading={uploadLoading}
          >
            <FileUploadOutlinedIcon />
          </LoadingButton>
        )}

        {image && image !== "close" && selectedFile && (
          <>
            {!previewImageLoading ? (
              <>
                <Tooltip title="Preview">
                  <LoadingButton
                    style={{
                      color: "var(--ds-text-primary)",
                      height: "30px",
                      borderRadius: "0px",
                      minWidth: "0px",
                      borderRight: "1px solid var(--ds-outline)",
                    }}
                    variant="text"
                    onClick={handlePreviewClick}
                    id="documentsPreviewButton"
                    loading={previewImageLoading}
                  >
                    <img src={uploadview} alt="" style={{ width: "20px" }} />
                  </LoadingButton>
                </Tooltip>
                <LoadingButton
                  style={{
                    // marginLeft: "10px",
                    color: "red",
                    height: "30px",
                    borderRadius: "0px",
                    minWidth: "0px",
                    // filter:
                    //   mode === "dark"
                    //     ? "grayscale(0.9) invert(0.9) brightness(2)"
                    //     : "",
                  }}
                  variant="text"
                  onClick={handledeleteImageClick}
                  color="error"
                  type="submit"
                  id="documentsDeleteButton"
                  loading={imagedeleteLoading}
                >
                  <img src={uploaddelete} alt="" style={{ width: "20px" }} />
                </LoadingButton>{" "}
              </>
            ) : (
              <LoadingButton
                variant="text"
                component="label"
                sx={{
                  display: "flex",
                  width: "max-content",
                  color: "var(--ds-text-primary)",
                  borderRadius: "0px",
                  boxShadow: "none",
                  minWidth: "unset",
                  fontSize: "12px",
                  padding: "0px 10px",
                }}
                onClick={handleUpload}
                id="documentsUploadButton"
                loading={true}
              >
                <FileUploadOutlinedIcon />
              </LoadingButton>
            )}
          </>
        )}
        {previewPDFFile && selectedFile && (
          <>
            {!previewLoading ? (
              <>
                <Tooltip title="Preview">
                  <LoadingButton
                    style={{
                      color: "var(--ds-text-primary)",
                      height: "30px",
                      borderRadius: "0px",
                      minWidth: "0px",
                      borderRight: "1px solid var(--ds-outline)",
                    }}
                    loading={previewLoading}
                    variant="text"
                    onClick={handlePreviewPDFClick}
                    id="documentsPDFPreviewButton"
                  >
                    <img src={uploadview} alt="" style={{ width: "20px" }} />
                  </LoadingButton>
                </Tooltip>
                <LoadingButton
                  style={{
                    // marginLeft: "10px",
                    color: "red",
                    height: "30px",
                    borderRadius: "0px",
                    minWidth: "30px",
                    // filter:
                    //   mode === "dark"
                    //     ? "grayscale(0.9) invert(0.9) brightness(2)"
                    //     : "",
                  }}
                  variant="text"
                  onClick={handledeleteClick}
                  color="error"
                  id="documentsPDFDeleteButton"
                  loading={pdfdeleteLoading}
                  type="submit"
                >
                  <img src={uploaddelete} alt="" style={{ width: "20px" }} />
                </LoadingButton>
              </>
            ) : (
              <LoadingButton
                variant="text"
                component="label"
                sx={{
                  display: "flex",
                  width: "max-content",
                  color: "var(--ds-text-primary)",
                  borderRadius: "0px",
                  boxShadow: "none",
                  minWidth: "unset",
                  fontSize: "12px",
                  padding: "0px 10px",
                }}
                onClick={handleUpload}
                id="documentsUploadButton"
                loading={true}
              >
                <FileUploadOutlinedIcon />
              </LoadingButton>
            )}
          </>
        )}
      </Stack>

      {showDragandDropModal && (
        <>
          <DragandDropFile
            showDragandDropModal={showDragandDropModal}
            handleCloseModal={handleCloseModal}
            handleFileChangeUpload={handleFileChangeUpload}
            acceptedFormats={acceptedFormats}
            errorMessage={errorMessage}
            selectedFile={selectedFile}
            showInput={showInput}
            image={image}
          />
        </>
      )}

      {showModal && (
        <Stack alignItems={"center"}>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={showModal}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={showModal}>
              <Box sx={style}>
                {selectedFile && selectedFile.type === "application/pdf" && (
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    margin={"0 30px"}
                  >
                    <Typography variant="h6">Preview</Typography>
                    <IconButton onClick={handleClosePdf}>
                      <ClearIcon />
                    </IconButton>
                  </Stack>
                )}

                <Stack
                  alignItems={"center"}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "90%",
                    objectFit: "contain",
                  }}
                >
                  {selectedFile && selectedFile.type === "application/pdf" ? (
                    <>
                      <div className={FormatStyles.pdfDesktopPreview}>
                        <embed
                          src={URL.createObjectURL(selectedFile)}
                          width="950"
                          height="100%"
                          type="application/pdf"
                        />
                      </div>
                      <div className={FormatStyles.pdfMobilePreview}>
                        <PdfModal url={URL.createObjectURL(selectedFile)} />
                      </div>
                      <div
                        style={{
                          display: "flex",

                          paddingTop: "5px",
                        }}
                      >
                        {showInput ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                style={{ marginRight: "10px" }}
                                id="outlined-basic"
                                label="Enter Password"
                                variant="outlined"
                                name="password"
                                size="small"
                                // value={pdfPassword}
                                onChange={(event) => {
                                  //  setPdfPassword(event.target.value);
                                  PasswordTyped = event.target.value;
                                }}
                                inputProps={{ maxLength: 15 }}
                              />
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  margin: "5px",
                                }}
                              >
                                If the File is Password Protected, Please Enter
                                the Password
                              </p>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <LoadingButton
                          sx={{
                            width: "150px",
                            height: "40px",
                            marginTop: "10px",
                          }}
                          variant="contained"
                          onClick={handlePdfPreviewDone}
                          id="documentsDoneButton"
                          loading={pdfUploadLoading}
                          type="submit"
                          // disabled = {showInput === false && pdfPassword === ""}
                        >
                          Upload
                        </LoadingButton>
                      </div>
                    </>
                  ) : (
                    <ReactCropper
                      imageSource={preview}
                      callBackImage={handleCallBack}
                      // documentRef={documentRef}
                      // callBackDocumentId={handleCallBackDocument}
                    />
                  )}
                </Stack>
              </Box>
            </Fade>
          </Modal>
        </Stack>
      )}

      {showPreviewModal && (
        <Stack alignItems={"center"}>
          <PreviewModalPopup
            selectedFile={selectedFile}
            image={image}
            documentName={documentRef}
            handleClosePreview={handleClosePreview}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default FormatterCheckerPanFetch;
